module.exports = __webpack_public_path__ + "static/media/check-box-ic.ebe18250.svg";